import React from 'react';
import { event as gaEvent } from '@/lib/gtag';

export default function Hero() {
  const handleApplyClick = (e: React.MouseEvent) => {
    e.preventDefault();
    gaEvent('click_cta', { location: 'hero', button: 'start' });
    window.REACT_APP_NAVIGATE('/login', { state: { from: '/order' } });
  };

  const handleTrialClick = (e: React.MouseEvent) => {
    e.preventDefault();
    gaEvent('click_cta', { location: 'hero', button: 'free_trial' });
    window.REACT_APP_NAVIGATE('/trial');
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="/8c2dd183c4f0ff4fa5c312dac8220061.jpg"
          alt="봄날 AI 웨딩 스튜디오"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      {/* Decorative circles */}
      <div className="absolute top-32 right-24 w-40 h-40 border border-white/15 rounded-full animate-pulse"></div>
      <div className="absolute bottom-40 left-16 w-24 h-24 border border-[#C9A96E]/30 rounded-full animate-pulse delay-1000"></div>

      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 py-40 text-center">
        <p className="text-[#C9A96E] text-xs tracking-[0.5em] uppercase mb-6 font-light animate-fade-in">
          AI Wedding Studio
        </p>

        <h1 className="font-serif text-6xl md:text-7xl lg:text-8xl font-light text-white mb-6 leading-tight tracking-tight">
          웨딩 사진,<br />
          <span className="italic font-normal">
            <span className="text-white/40 line-through text-4xl md:text-5xl lg:text-6xl">49,000원</span>{' '}
            19,900원부터
          </span>
        </h1>

        <p className="text-white/85 text-base md:text-lg max-w-2xl mx-auto mb-4 font-light leading-relaxed">
          사진 2~3장만 올려주세요. AI가 당신만의 특별한 웨딩 스냅 사진을 만들어드립니다.
        </p>
        <p className="text-[#C9A96E] text-sm mb-2 font-light tracking-wide">
          웨딩 촬영 비용의 <strong className="font-medium">최대 99% 절감</strong> · 당일 결과물 수령
        </p>
        <p className="text-white/70 text-xs mb-12 font-light tracking-wide">
          각 사진당 <strong className="text-[#C9A96E] font-medium">2번까지 무료 재생성</strong> 가능
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={handleApplyClick}
            className="group w-52 py-4 bg-[#C9A96E] text-white text-sm font-medium tracking-wide rounded-full hover:bg-[#b8935a] transition-all duration-300 cursor-pointer whitespace-nowrap shadow-xl hover:shadow-2xl hover:scale-105 inline-flex items-center justify-center gap-2"
          >
            <i className="ri-camera-ai-line text-base"></i>
            시작하기
          </button>
          <button
            onClick={handleTrialClick}
            className="group w-52 py-4 border border-white/60 text-white text-sm font-medium tracking-wide rounded-full hover:bg-white/10 transition-all duration-300 cursor-pointer whitespace-nowrap backdrop-blur-sm shadow-xl hover:shadow-2xl hover:scale-105 inline-flex items-center justify-center gap-2"
          >
            <i className="ri-gift-line text-base"></i>
            무료 체험하기
          </button>
        </div>

        {/* Stats */}
        <div className="mt-20 flex items-center justify-center gap-12 flex-wrap">
          {[
            { num: '19,900원~', label: '베이직 시작가' },
            { num: '당일', label: '결과물 수령' },
            { num: '99%↓', label: '촬영 비용 절감' },
          ].map(s => (
            <div key={s.label} className="text-center">
              <p className="text-white text-2xl font-serif font-medium">{s.num}</p>
              <p className="text-white/60 text-xs mt-1 tracking-wide">{s.label}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/50 text-xs tracking-widest">SCROLL</span>
        <i className="ri-arrow-down-line text-white/50 text-lg"></i>
      </div>
    </section>
  );
}
